import React, { useEffect, useState, createContext, useContext } from 'react';
type DarkModeContextType = {
  darkMode: boolean;
  toggleDarkMode: () => void;
};
const DarkModeContext = createContext<DarkModeContextType>({
  darkMode: true,
  toggleDarkMode: () => {}
});
export const DarkModeProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  // Default to dark mode
  const [darkMode, setDarkMode] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);
  // Load dark mode setting on component mount
  useEffect(() => {
    const savedDarkMode = localStorage.getItem('darkMode');
    // Only use saved preference if user has explicitly set one
    // Otherwise default to dark mode
    const shouldBeDark = savedDarkMode !== null ? savedDarkMode === 'true' : true;
    setDarkMode(shouldBeDark);
    setIsInitialized(true);
    // Apply dark mode to the whole document
    if (shouldBeDark) {
      document.documentElement.classList.add('dark-mode');
      document.body.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark-mode');
      document.body.classList.remove('dark');
    }
  }, []);
  // Apply dark mode classes immediately on initial render to prevent flash
  useEffect(() => {
    if (!isInitialized) {
      // Apply dark mode immediately before localStorage check completes
      document.documentElement.classList.add('dark-mode');
      document.body.classList.add('dark');
    }
  }, [isInitialized]);
  // Toggle dark mode and save to localStorage
  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    // Save preference to localStorage so it persists
    localStorage.setItem('darkMode', newDarkMode.toString());
    // Apply dark mode to the whole document
    if (newDarkMode) {
      document.documentElement.classList.add('dark-mode');
      document.body.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark-mode');
      document.body.classList.remove('dark');
    }
  };
  return <DarkModeContext.Provider value={{
    darkMode,
    toggleDarkMode
  }} data-id="element-4122" data-mp="33mx95gahw1jn">
      {children}
    </DarkModeContext.Provider>;
};
export const useDarkMode = () => useContext(DarkModeContext);